import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

import ReportingAgencyPopUp from "../Modals/ReportingAgencyPopUp";
import InsuranceCompanyPopUp from "../Modals/InsuranceCompanyPopUp";
import InsuranceAdjusterPopUp from "../Modals/InsuranceAdjusterPopUp";
import DisabilityAgencyPopUp from "../Modals/DisabilityAgencyPopUp";
import ExpertPopUp from "../Modals/ExpertPopUp";
import LawFirmModal from "../Modals/LawFirmModal";
import AttorneyModal from "../Modals/AttorneyModal";
import LoanCaseModal from "../Modals/LoanCaseModal";
import CourtDirectoryModal from "../Modals/CourtDirectoryModal";
import JudgeDirectoryModal from "../Modals/JudgeDirectoryModal";
import AddDepartmentModal from "../Modals/AddDepartmentModal";
import LitigationEventModal from "../Modals/LitigationEventModal";
import TimeCodeModal from "../Modals/TimeCodeModal";
import AddStatutesModal from "../Modals/AddStatutesModal";
import AddProcessorServerModal from "../Modals/AddProcessorServerModal";
import AddCourtDistrictModal from "../Modals/AddCourtDistrictModal";
import AddJurisdictionModal from "../Modals/AddJurisdictionModal";
import AddDivisionModal from "../Modals/AddDivisionModal";
import AddCircuitModal from "../Modals/AddCircuitModal";
import AddCourtFormsModal from "../Modals/AddCourtFormsModal";
import AddCalculatedDatesModal from "../Modals/AddCalculatedDateModal";
import DependantDateTypeModal from "../Modals/DependantDateTypeModal";
import ExpertCategoryModal from "../Modals/ExpertCategoryModal";
import ClickKeyModal from "../Modals/ClickKeyModal";
import StatusesModal from "../Modals/StatusesModal";
import ChecklistsModal from "../Modals/ChecklistsModal";
import PanelChecklistsModal from "../Modals/PanelChecklistModal";
import WorkunitModal from "../Modals/WorkunitModal";
import ActModal from "../Modals/ActModal";
import AutomationRulePopUp from "../Modals/AutomationRulePopUp";
import RuleFieldPopUp from "../Modals/RuleFieldPopUp";
import RuleActionPopUp from "../Modals/RuleActionPopUp";
import RuleDependencyPopUp from "../Modals/RuleDependencyPopUp";
import SpecialitySearchDropdown from "../common/SpecialitySearchDropdown";
import NewDirectoryProviderModal from "../Modals/NewDirectoryProviderModal";
import DirectoryStateDropdown from "../common/DirectoryStateDropdown";
import JurisdictionTypeSelect from "../common/JurisdictionTypeSelect";
import EventTypeDropdownSelect from "../common/EventTypeDropdownSelect";
import addIconGold from "../../assets/Add-icon-gold.svg";
import SOLTemplateAddPopup from "../Modals/SOLTemplateAddPopup";

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const SearchTab = ({ onTabChange, currentTab }) => {
  const [activeTabText, setActiveTabText] = useState("Accounts");
  const searchInputRef = useRef(null);
  const [buttonText, setButtonText] = useState("Accounts");
  const [popups, setPopups] = useState({
    "CoPilot Firms": false,
    "Reporting Agency": false,
    "Insurance Company": false,
    "Insurance Adjuster": false,
    "Disability Agency": false,
    Experts: false,
    "Law Firm": false,
    Attorney: false,
    "Case Loan": false,
    Courts: false,
    Judges: false,
    Department: false,
    Provider: false,
    "Litigation Event": false,
    "Statute of Limitations": false,
    "Time Codes": false,
    Statute: false,
    "Process Server": false,
    Jurisdiction: false,
    "Court District": false,
    Division: false,
    Circuit: false,
    "Court Forms": false,
    "Calculated Dates": false,
    "Dependant Date Types": false,
    "Expert Specialties": false,
    "Click Key": false,
    Statuses: false,
    Checklists: false,
    "Panel Checklists": false,
    WorkUnits: false,
    Acts: false,
    "Automation Rule": false,
    "Rule Field": false,
    "Rule Action": false,
    "Rule Dependency": false,
  });

  const admin = localStorage.getItem("directoryAdmin") === "true" ? true : false;
  const tabs = admin
    ? [
        { label: "CoPilot Firms", value: "copilotfirms" },
        { label: "Attorney", value: "attorney" },
        { label: "Law Firm", value: "law-firm" },
        { label: "Courts", value: "courts" },
        { label: "Judges", value: "judge" },
        { label: "Provider", value: "provider" },
        { label: "Experts", value: "experts" },
        { label: "Reporting Agency", value: "reporting-agency" },
        { label: "Insurance Company", value: "insurance-company" },
        { label: "Insurance Adjuster", value: "insurance-adjuster" },
        { label: "Disability Agency", value: "disability-agency" },
        { label: "Case Loan", value: "case-loan" },
        { label: "Department", value: "department" },
        { label: "Court District", value: "court-district" },
        { label: "Jurisdiction", value: "jurisdiction" },
        { label: "Division", value: "division" },
        { label: "Circuit", value: "circuit" },
        { label: "Court Forms", value: "courtForms" },
        { label: "Expert Specialties", value: "expertSpecialties" },
        { label: "Time Codes", value: "time-codes" },
        { label: "Statute", value: "statute" },
        { label: "Process Server", value: "process-server" },
        { label: "Litigation Event", value: "litigation-event" },
        { label: "Statute of Limitations", value: "sol-template" },
        { label: "Calculated Dates", value: "calculatedDates" },
        { label: "Dependant Date Types", value: "dependantDateTypes" },
        { label: "Click Key", value: "clickKeys" },
        { label: "Statuses", value: "statuses" },
        { label: "Checklists", value: "checklists" },
        { label: "Panel Checklists", value: "panelChecklists" },
        { label: "WorkUnits", value: "workunits" },
        { label: "Acts", value: "acts" },
        { label: "Automation Rule", value: "automation-rule" },
        { label: "Rule Field", value: "rule-field" },
        { label: "Rule Action", value: "rule-action" },
        { label: "Rule Dependency", value: "rule-dependency" },
        { label: "Automation Event", value: "automation-event" },
      ]
    : [
        { label: "CoPilot Firms", value: "copilotfirms" },
        { label: "Attorney", value: "attorney" },
        { label: "Law Firm", value: "law-firm" },
        { label: "Courts", value: "courts" },
        { label: "Judges", value: "judge" },
        { label: "Provider", value: "provider" },
        { label: "Experts", value: "experts" },
        { label: "Reporting Agency", value: "reporting-agency" },
        { label: "Insurance Company", value: "insurance-company" },
        { label: "Insurance Adjuster", value: "insurance-adjuster" },
        { label: "Disability Agency", value: "disability-agency" },
        { label: "Case Loan", value: "case-loan" },
      ];

  const [_dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 1000);

    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  const togglePopup = (popupName) => {
    setPopups((prevPopups) => ({
      ...prevPopups,
      [popupName]: !(prevPopups[popupName] || false),
    }));
  };

  const closePopup = (popupName) => {
    setPopups((prevPopups) => ({
      ...prevPopups,
      [popupName]: false,
    }));
  };

  function getOutputText(input) {
    switch (true) {
      case input.includes("Accounts"):
        return "Accounts";
      case input.includes("Reporting"):
        return "Reporting Agency";
      case input.includes("Insurance Adjuster"):
        return "Insurance Adjuster";
      case input.includes("Disability Agency"):
        return "Disability Agency";
      case input.includes("Insurance Company"):
        return "Insurance Company";
      case input.includes("Experts"):
        return "Expert";
      case input.includes("Law Firm"):
        return "Law Firm";
      case input.includes("Attorney"):
        return "Attorney";
      case input.includes("Case Loan"):
        return "Case Loan";
      case input.includes("Courts"):
        return "Courts";
      case input.includes("Judges"):
        return "Judges";
      case input.includes("Department"):
        return "Department";
      case input.includes("Provider"):
        return "Provider";
      case input.includes("Litigation Event"):
        return "Litigation Event";
      case input.includes("Statute of Limitations"):
        return "Statute of Limitations";
      case input.includes("Time Codes"):
        return "Time Codes";
      case input.includes("Statute"):
        return "Statute";
      case input.includes("Process Server"):
        return "Process Server";
      case input.includes("Court District"):
        return "Court District";
      case input.includes("Jurisdiction"):
        return "Jurisdiction";
      case input.includes("Division"):
        return "Division";
      case input.includes("Circuit"):
        return "Circuit";
      case input.includes("Court Forms"):
        return "Court Forms";
      case input.includes("Calculated Dates"):
        return "Calculated Dates";
      case input.includes("Dependant"):
        return "Dependant Date Types";
      case input.includes("Expert Specialties"):
        return "Expert Specialties";
      case input.includes("Click Key"):
        return "Click Key";
      case input.includes("Statuses"):
        return "Statuses";
      case input.includes("Checklists"):
        return "Checklists";
      case input.includes("Panel Checklists"):
        return "Panel Checklists";
      case input.includes("WorkUnits"):
        return "WorkUnits";
      case input.includes("Acts"):
        return "Acts";
      case input.includes("Automation Rule"):
        return "Automation Rule";
      case input.includes("Rule Field"):
        return "Rule Field";
      case input.includes("Rule Action"):
        return "Rule Action";
      case input.includes("Rule Dependency"):
        return "Rule Dependency";
      case input.includes("Automation Event"):
        return "Automation Event";
      case input.includes("CoPilot"):
        return "CoPilot Firms";
      default:
        return "Court District";
    }
  }

  useEffect(() => {
    const selectedTabLabel = tabs.find((tab) => tab.value === currentTab)?.label || "Accounts";
    setActiveTabText(selectedTabLabel);
    setButtonText(selectedTabLabel);
  }, [currentTab]);

  const filterTabEntries = () => {
    const searchText = searchInputRef.current.value.toLowerCase().trim();
    const tables = document.querySelectorAll(".custom-table-directory, .law-firm-list");

    tables.forEach((table) => {
      const rows = table.querySelectorAll("tbody tr");
      let visibleRowIndex = 1; // Start indexing from 1
      const colSpan = table.querySelectorAll("thead tr th").length;

      rows.forEach((row) => {
        if (searchText.length > 1) {
          let shouldShow = false;

          const cellsToSearch = [...row.querySelectorAll(".is-search")];

          // Split the cleaned search text into individual words
          const searchWords = searchText.split(" ").filter((word) => word.length > 0);

          // Check if any cell matches the search words starting from the beginning of the word
          shouldShow = cellsToSearch.some((cell) => {
            if (cell) {
              const cellText = cell.textContent.toLowerCase().trim();

              // Check if every search word matches the start of at least one word in the cell
              return searchWords.every((searchWord) => cellText.includes(searchWord));
            }
            return false;
          });

          row.classList.remove("filtered-row", "even", "odd");
          // if (row.classList.contains("no-search")) {
          //   shouldShow = false;
          // }
          if (shouldShow) {
            row.style.display = "table-row";
            row.querySelector("td:first-child").textContent = visibleRowIndex;
            visibleRowIndex += 1;
            row.classList.add("filtered-row");
            row.classList.add(visibleRowIndex % 2 === 1 ? "odd" : "even");
          } else {
            row.style.display = "none";
          }
        } else {
          row.style.display = "table-row";
        }
      });

      const tbody = table.querySelector("tbody");

      const fakeRows = table.querySelectorAll(".fake-row-2");
      fakeRows.forEach((fakeRow) => {
        if (fakeRow.parentNode) {
          fakeRow.remove();
        }
      });

      if (searchText !== "") {
        const tableBottom = table.getBoundingClientRect().bottom;
        const pageHeight = window.innerHeight;

        const rowHeight = 70; // Assuming each row is 70px high
        const remainingHeight = pageHeight - tableBottom;

        let rowsNeeded = Math.ceil(remainingHeight / rowHeight);
        if (rowsNeeded > 0) {
          rowsNeeded -= 1;
        }

        for (let i = 0; i < rowsNeeded; i++) {
          const fakeRow = document.createElement("tr");
          fakeRow.className = "fake-row-2";
          fakeRow.style.height = `${rowHeight}px`;

          const td = document.createElement("td");
          td.colSpan = colSpan;
          td.innerHTML = "&nbsp;";
          fakeRow.appendChild(td);
          tbody.appendChild(fakeRow);
        }
      }
    });
  };

  const handleInputChange = () => {
    filterTabEntries();
  };

  useEffect(() => {
    filterTabEntries();

    const handleResize = () => {
      filterTabEntries();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleInputLowercase = (e) => {
    e.target.value = e.target.value.toLowerCase();
  };

  useEffect(() => {
    const inputsEmail = document.querySelectorAll("input[name*=email]");
    const inputsWebsite = document.querySelectorAll("input[name*=website]");

    inputsEmail.forEach((input) => input.addEventListener("keyup", handleInputLowercase));
    inputsWebsite.forEach((input) => input.addEventListener("keyup", handleInputLowercase));

    return () => {
      inputsEmail.forEach((input) => input.removeEventListener("keyup", handleInputLowercase));
      inputsWebsite.forEach((input) => input.removeEventListener("keyup", handleInputLowercase));
    };
  }, []);

  const handleButtonClick = () => {
    const popupName = tabs.find((tab) => tab.value === currentTab)?.label;
    if (popupName) {
      togglePopup(popupName);
    }
  };

  const isSearchDisabled = useSelector((state) => state.directory.isSearchDisabled);

  const [isTabDropdownOpen, setIsTabDropdownOpen] = useState(false);

  const _handleTabDropdownToggle = () => {
    setIsTabDropdownOpen(!isTabDropdownOpen);
  };

  const handleTabSelect = (value) => {
    onTabChange(value);
    setIsTabDropdownOpen(false); // Close the dropdown after selection
  };
  const tabDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tabDropdownRef.current && !tabDropdownRef.current.contains(event.target)) {
        setIsTabDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [tabDropdownRef]);
  return (
    <div className="nav nav-tabs mb-1 h-auto overflow-visible" role="tablist">
      <div className="d-flex align-items-center w-100" style={{ marginTop: "5px" }}>
        {/* <div className="search-tab-wrapper position-relative">
          <button
            className="btn btn-primary dropdown-toggle py-0 height-25"
            type="button"
            onClick={handleTabDropdownToggle}
          >
            {tabs.find((tab) => tab.value === currentTab)?.label || "Select Tab"}
          </button>

          {isTabDropdownOpen && (
            <ul className="dropdown-menu show position-absolute z-2 w-100 p-0">
              {tabs.map((tab, index) => (
                <li key={tab.value}>
                  <button
                    className={`dropdown-item ${currentTab === tab.value ? "active" : ""} py-0 px-3 height-25`}
                    onClick={() => handleTabSelect(tab.value)}
                    style={{
                      backgroundColor: index % 2 === 0 ? "var(--primary-5)" : "var(--primary-10)",
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div> */}
        {/* <div
          ref={tabDropdownRef}
          className={"height-25 p-l-0 pe-0 custom-select-new-provider"}
          style={{
            position: "relative",
          }}
        >
          <div
            className="dropdown-button form-control pt-0 pb-0  pe-0 height-25 d-flex align-items-center"
            onClick={() => setIsTabDropdownOpen((prev) => !prev)}
            style={{
              paddingLeft: currentTab ? "0px" : "5px",
              color: "black",
              minWidth: "220px",
            }}
          >
            <span id="selectedOption">
              {currentTab ? (
                <div
                  className="d-flex p-l-5 align-items-center justify-content-start "
                  style={{
                    height: "25px",
                    fontSize: "16px",
                    color: "black",
                    fontWeight: "700",
                    gap: "5px",
                  }}
                >
                  {tabs.find((tab) => tab.value === currentTab)?.label}
                </div>
              ) : (
                "Select Tab"
              )}
            </span>
          </div>

          {isTabDropdownOpen && (
            <div
              className="dropdown-menu p-0 mt-0"
              style={{
                width: "220px",
                border: "1px solid #ced4da",
                // borderRadius: "2px",
                scrollbarWidth: "none",
                maxHeight: "450px",
                fontSize: "16px",
                overflowY: "auto",
              }}
            >
              {tabs?.map((special, idx) => (
                <div>
                  <div
                    key={special.id}
                    className="dropdown-option  d-flex align-items-center height-25"
                    style={{
                      // backgroundColor: mixColorWithWhite(
                      //   special?.color,
                      //   10
                      // ),
                      color: "black",
                      fontWeight: "400",
                      fontSize: "16px",
                      cursor: "pointer",
                      paddingLeft: "5px",
                      backgroundColor: idx % 2 === 0 ? "var(--primary-5)" : "var(--primary-10)",
                    }}
                    onClick={() => handleTabSelect(special.value)}
                  >
                    {special.label}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div> */}
        <div
          ref={tabDropdownRef}
          className={"height-25 p-l-0 pe-0 custom-select-new-provider"}
          style={{
            position: "relative",
          }}
        >
          <div
            className="dropdown-button form-control pt-0 pb-0 pe-0 height-25 d-flex align-items-center"
            onClick={() => setIsTabDropdownOpen((prev) => !prev)}
            style={{
              paddingLeft: currentTab ? "0px" : "5px",
              color: "black",
              minWidth: "220px",
            }}
          >
            <span id="selectedOption">
              {currentTab ? (
                <div
                  className="d-flex p-l-5 align-items-center justify-content-start"
                  style={{
                    height: "25px",
                    fontSize: "16px",
                    color: "black",
                    fontWeight: "700",
                    gap: "5px",
                  }}
                >
                  {tabs.find((tab) => tab.value === currentTab)?.label}
                </div>
              ) : (
                "Select Tab"
              )}
            </span>
          </div>

          {/* Dropdown menu - Dynamic Multi-Column Layout */}
          {isTabDropdownOpen && (
            <div
              className="d-grid search-tab-grid p-0 mt-0"
              style={{
                width: "auto",
                minWidth: "220px",
                border: "1px solid #ced4da",
                scrollbarWidth: "none",
                maxHeight: "450px",
                fontSize: "16px",
                overflowY: "auto",
                position: "absolute",
                zIndex: "999",
                background: "white",
                gridTemplateColumns: "repeat(3, auto)", // Dynamic width per column
                gridAutoFlow: "column", // Fill columns vertically first
                gridTemplateRows: `repeat(${Math.ceil(tabs.length / 3)}, auto)`, // Calculate rows needed
              }}
            >
              {tabs?.map((special, idx) => {
                // Calculate row and column for checkerboard pattern
                const itemsPerColumn = Math.ceil(tabs.length / 3);
                const col = Math.floor(idx / itemsPerColumn);
                const row = idx % itemsPerColumn;
                const isEvenCell = (row + col) % 2 === 0;

                return (
                  <div
                    key={special.id}
                    className="dropdown-option d-flex align-items-center height-25"
                    style={{
                      color: "black",
                      fontWeight: "400",
                      fontSize: "16px",
                      cursor: "pointer",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      whiteSpace: "nowrap", // Prevent text wrapping
                      backgroundColor: isEvenCell ? "var(--primary-5)" : "var(--primary-10)",
                    }}
                    onClick={() => handleTabSelect(special.value)}
                  >
                    {special.label}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {activeTabText === "Provider" && <SpecialitySearchDropdown />}
        <input
          type="text"
          style={{
            flex: 1,
          }}
          className="form-control py-0 height-25"
          placeholder={`Enter Text to filter by ${activeTabText}`}
          ref={searchInputRef}
          id="search_filter_directories"
          onChange={handleInputChange}
          disabled={isSearchDisabled}
        />
        <DirectoryStateDropdown />
        {(activeTabText === "Litigation Event" || activeTabText === "Court Forms") && (
          <JurisdictionTypeSelect />
        )}
        {activeTabText === "Court Forms" && <EventTypeDropdownSelect />}
        {admin && (
          <div className="d-flex justify-content-end p-l-4">
            <button
              className="fw-bold btn btn-primary me-1 d-flex align-items-center py-0 height-25"
              onClick={handleButtonClick}
              style={{
                gap: "5px",
              }}
            >
              <span style={{ color: "gold" }}>
                <img
                  src={addIconGold}
                  className="ic ic-15 d-flex align-items-center justify-content-center"
                />
              </span>{" "}
              {getOutputText(buttonText)}
            </button>
          </div>
        )}
      </div>
      <>
        {Object.keys(popups).map((popupName, index) => (
          <React.Fragment key={index}>
            {popupName === "Reporting Agency" && popups[popupName] && (
              <ReportingAgencyPopUp
                reportingAgencyPopup={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Insurance Company" && popups[popupName] && (
              <InsuranceCompanyPopUp
                insuranceCompanyPopup={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Insurance Adjuster" && popups[popupName] && (
              <InsuranceAdjusterPopUp
                insuranceAdjusterPopup={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Disability Agency" && popups[popupName] && (
              <DisabilityAgencyPopUp
                disabilityAgencyPopup={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Experts" && popups[popupName] && (
              <ExpertPopUp
                expertPopup={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Law Firm" && popups[popupName] && (
              <LawFirmModal
                lawFirmPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Attorney" && popups[popupName] && (
              <AttorneyModal
                attorneyPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Case Loan" && popups[popupName] && (
              <LoanCaseModal
                loanCasePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Courts" && popups[popupName] && (
              <CourtDirectoryModal
                courtPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Judges" && popups[popupName] && (
              <JudgeDirectoryModal
                judgePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Provider" && popups[popupName] && (
              <NewDirectoryProviderModal
                providerPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Department" && popups[popupName] && (
              <AddDepartmentModal
                departmentPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Litigation Event" && popups[popupName] && (
              <LitigationEventModal
                litigationEventPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Statute of Limitations" && popups[popupName] && (
              <SOLTemplateAddPopup
                solTemplatePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Time Codes" && popups[popupName] && (
              <TimeCodeModal
                timeCodePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Statute" && popups[popupName] && (
              <AddStatutesModal
                statuesPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Process Server" && popups[popupName] && (
              <AddProcessorServerModal
                addProcessorServers={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Jurisdiction" && popups[popupName] && (
              <AddJurisdictionModal
                addJurisdictions={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Court District" && popups[popupName] && (
              <AddCourtDistrictModal
                addCourtDistrict={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Division" && popups[popupName] && (
              <AddDivisionModal
                addDivisions={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Circuit" && popups[popupName] && (
              <AddCircuitModal
                addCircuits={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Court Forms" && popups[popupName] && (
              <AddCourtFormsModal
                courtFormPopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Calculated Dates" && popups[popupName] && popups[popupName] && (
              <AddCalculatedDatesModal
                calculatedDatePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Dependant Date Types" && popups[popupName] && (
              <DependantDateTypeModal
                dateTypePopUp={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Expert Specialties" && popups[popupName] && (
              <ExpertCategoryModal
                addCategory={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Click Key" && popups[popupName] && (
              <ClickKeyModal
                addClickKeys={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Statuses" && popups[popupName] && (
              <StatusesModal
                addStatuses={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Checklists" && popups[popupName] && (
              <ChecklistsModal
                addChecklists={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Panel Checklists" && popups[popupName] && (
              <PanelChecklistsModal
                addPanelChecklists={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "WorkUnits" && popups[popupName] && (
              <WorkunitModal
                addWorkunits={popups[popupName]}
                handleClose={() => closePopup(popupName)}
              />
            )}
            {popupName === "Acts" && popups[popupName] && (
              <ActModal addActs={popups[popupName]} handleClose={() => closePopup(popupName)} />
            )}
            {popupName === "Automation Rule" && popups[popupName] && (
              <AutomationRulePopUp
                editRule={popups[popupName]}
                handleClose={() => closePopup(popupName)}
                ruleData={null}
              />
            )}
            {popupName === "Rule Field" && popups[popupName] && (
              <RuleFieldPopUp
                editField={popups[popupName]}
                handleClose={() => closePopup(popupName)}
                fieldData={null}
              />
            )}
            {popupName === "Rule Action" && popups[popupName] && (
              <RuleActionPopUp
                editAction={popups[popupName]}
                handleClose={() => closePopup(popupName)}
                actionData={null}
              />
            )}
            {popupName === "Rule Dependency" && popups[popupName] && (
              <RuleDependencyPopUp
                editDep={popups[popupName]}
                handleClose={() => closePopup(popupName)}
                depData={null}
              />
            )}
            {popupName === "Automation Event" && <></>}
          </React.Fragment>
        ))}
      </>
    </div>
  );
};

export default SearchTab;
